module.exports = __webpack_public_path__ + "static/living_room_night_mobile-602e6c97baff266709336bcdbed7c7ee.jpg";